module.exports = __webpack_public_path__ + "static/img/wulian.f0fd2cf4.png";